/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_043: Question = {
  id: 'pres-043-directive-gestion-eee',
  oldId: '57',
  title: 'Établissement d’une directive de gestion des EEE pour les travaux effectués en régie',
  number: '4.5',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: niveauActions,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_043__v3: Question = {
  ...question_pres_043,
  frequency: 4,
};

export const question_pres_043_v2: Question = question_pres_043;
export const question_pres_043_v3: Question = question_pres_043__v3;
